import React, { Component } from "react";
import { verifyOtp } from "../network/api";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateIsLogin } from "../redux/actions";
import { getSessionKeyId, login, setToken } from "../authentication/authorizer";
import {
  code_sent_prefix,
  code_sent_suffix,
  confirm,
  error_dots,
  confirmation_code,
} from "../resources/string/strings";

class AuthenticationCode extends Component {
  state = {
    pageTitle: "ورود به حساب",
    pageTag: "authenticationCode",
    code: "",
    error: "",
    loading: false,
  };

  componentDidMount() {
    document.title = this.state.pageTitle;
  }

  render() {
    return (
      <div className="fragment">
          <div className="app-card mx-auto text-center bg-white col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6">
          <div className="card-body">
            <h5 className="text-lg mt-2 mb-2">
              {code_sent_prefix} {this.getMobile()} {code_sent_suffix}
            </h5>
            <p className="mb-5" style={{ fontSize: 12, color: "Green" }}>
              <strong>{this.getQueryString("un")}</strong>
            </p>
            <form onSubmit={this.handleSubmit}>
              <input
                style={{ width: 280, height: 45, paddingBottom: 3 }}
                className="input-group-text mb-4 mx-auto text-center"
                type="text"
                pattern="[0-9]*"
                name="code"
                placeholder={confirmation_code}
                maxLength="6"
                value={this.state.code}
                onChange={this.handleFormChange}
                required
              />
              <button
                style={{ width: 280, height: 45 }}
                className="btn btn-success mb-4 mx-auto text-center"
                type="submit"
                disabled={this.state.loading}
              >
                <div>{confirm}</div>
              </button>
            </form>
            {this.state.error.length > 0 && (
              <p style={{ width: 280 }} className="alert alert-danger mx-auto">
                <strong>{error_dots}</strong>
                {this.state.error}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }

  handleFormChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      error: "",
    });
  };

  handleSubmit = (event) => {
    this.callVerifyOtpApi();
    event.preventDefault();
  };

  getQueryString(key) {
    const query = new URLSearchParams(this.props.location.search);
    const id = query.get(key);
    return id;
  }

  getMobile() {
    return this.getQueryString("mo")
  }

  /****
   ** NETWORK
   *****/

  callVerifyOtpApi = () => {
    this.setState({ loading: true });
    const { code } = this.state;
    verifyOtp(code, getSessionKeyId(), this.handleVerifyOtpApiSuccess, this.handleVerifyOtpApiFailure);
  };

  handleVerifyOtpApiSuccess = (data) => {
    login()
    setToken(data.token, data.expirationTime)
    this.props.updateIsLogin("true")
    this.props.history.push({
      pathname: "/dashboard"
    });
  };

  handleVerifyOtpApiFailure = (error) => {
    this.setState({ loading: false});
  };
}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ updateIsLogin: updateIsLogin }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(AuthenticationCode);
